import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { addEmail, getAuthError, getUserLoadingState } from '../../../store/slices/authSlice';
import CustomButton, { BUTTON_STYLE_TYPE } from '../../common/Button';
import styles from './styles.module.scss';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// HORO-10509: shown after an OAuth (mainly Facebook) login where the
// provider didn't return an email — this is where "enforce sharing of
// email address" actually lands for the user who declined it at the
// provider level. Requires an existing session (dispatched only once
// authUser has already succeeded — see useAuth.js).
const AddEmailStep = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const loading = useSelector(getUserLoadingState);
    const error = useSelector(getAuthError);
    const {
        register,
        handleSubmit,
        trigger,
        formState: { errors, isValid, touchedFields }
    } = useForm({ mode: 'onChange' });

    // See SetPasswordStep's identical note — isValid otherwise reports
    // true on mount before the field has been validated.
    useEffect(() => {
        trigger();
    }, [trigger]);

    const onSubmit = ({ email }) => {
        if (loading) {
            return;
        }
        dispatch(addEmail(email.trim().toLowerCase()));
    };

    return (
        <>
            <h2 className={`${styles.title} ${styles.titleMixedCase}`}>{t('modal.addEmailTitle')}</h2>
            <p className={styles.subtitle}>{t('modal.addEmailLabel')}</p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.inputWrapper}>
                    <input
                        className={styles.fieldInput}
                        type="email"
                        autoComplete="email"
                        placeholder={t('modal.emailPlaceholder')}
                        {...register('email', { required: true, pattern: EMAIL_REGEX })}
                    />
                    {errors.email && touchedFields.email && (
                        <span className={styles.error}>{t('errors.invalidEmail', 'Enter a valid email address')}</span>
                    )}
                </div>
                {error && <p className={styles.formError}>{error.message}</p>}
                <div className={styles.submitBtnWrap}>
                    <CustomButton
                        text={t('buttons.submit')}
                        loading={loading}
                        disable={loading || !isValid}
                        styleType={BUTTON_STYLE_TYPE.PURPLE}
                    />
                </div>
            </form>
        </>
    );
};

export default AddEmailStep;
